var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0768 23.517L19.3004 22.3017V15.1179L17.7842 13.5515H25.4184L23.849 15.1449V22.3017L25.0726 23.544L18.0768 23.517Z",
    fill: "#FFF0B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.496 23.517L11.693 22.3017V15.1179L10.1768 13.5515H17.811L16.2682 15.1449V22.3017L17.4918 23.544L10.496 23.517Z",
    fill: "#FFF0B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88854 23.517L4.08554 22.3017V15.1179L2.56934 13.5515H10.2301L8.66074 15.1449V22.3017L9.88434 23.544L2.88854 23.517Z",
    fill: "#FFF0B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5283 1.1823L1.23912 12.7952C0.813518 13.2273 1.10612 13.9565 1.69132 13.9565H26.2431C26.8283 13.9565 27.1209 13.2003 26.6953 12.7952L14.4327 1.1823C14.1667 0.939235 13.7677 0.939235 13.5283 1.1823Z",
    fill: "url(#paint0_linear_1522_20837)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.137 28H1.7714C1.3458 28 1 27.649 1 27.2169V24.1111C1 23.679 1.3458 23.3279 1.7714 23.3279H26.137C26.5626 23.3279 26.9084 23.679 26.9084 24.1111V27.2169C26.9084 27.649 26.5626 28 26.137 28Z",
    fill: "url(#paint1_linear_1522_20837)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.981 11.2831C15.2444 11.2831 16.2686 10.2432 16.2686 8.96052C16.2686 7.67779 15.2444 6.63794 13.981 6.63794C12.7176 6.63794 11.6934 7.67779 11.6934 8.96052C11.6934 10.2432 12.7176 11.2831 13.981 11.2831Z",
    fill: "#FFF6C9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_20837",
    x1: 13.9712,
    y1: 13.9619,
    x2: 13.9712,
    y2: 0.993249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1522_20837",
    x1: 13.9542,
    y1: 28,
    x2: 13.9542,
    y2: 23.3531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6E00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlLogo);
export default __webpack_public_path__ + "static/media/sl-logo.75ac51eafad3540adba9369c9c4287f9.svg";
export { ForwardRef as ReactComponent };